import { FC, useEffect, useState } from 'react'

import { Text, MonoSpaced12SemiBold } from '@sequencehq/core-components'

export const VariableInlineContentWidget: FC<{
  contentRef: (node: HTMLElement | null) => void
}> = ({ contentRef }) => {
  /**
   * When adding a quote variable, this element doesn't render the text content within it. It does appear when
   * you reload the editor, or when you press CMD+A. To work around this, when this component is mounted,
   * assign a random value as the key to force a rerender.
   */
  const [key, setKey] = useState<string | undefined>()
  useEffect(() => {
    setKey(crypto.randomUUID())
  }, [])

  return (
    <Text
      key={key}
      ref={contentRef}
      as="span"
      display="inline"
      contentEditable={false}
      fontWeight="inherit"
      fontSize="inherit"
      fontFamily={MonoSpaced12SemiBold.fontFamily}
      _before={{ content: '"{"' }}
      _after={{ content: '"}"' }}
    />
  )
}
